import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.b``;

export default function Bold({ children }) {
  return <Wrapper>{children}</Wrapper>;
}
